import actions from './actions';
const initState = {
  idToken: null,
  errorMessage: null,
  forgotMessage: null,
  modules: null,
  customModules: null,
  roles: null,
  isLoading: false,
  resetSuccess: false,
  identity: null,
  stores: null,
  secondTimer: 0,
  env: null,
  topic: null,
  mqttToken: null,
  forbiddenRequest: false,
  kickedOut: false,
  customAuthorizations: null,
  disabledModules: ['CORPORATE_STORE_USER', 'CORPORATE_ADDRESS_BOOK'],
  disabledSubmodules: ['MERCHANT_BATCH_UPLOAD'],
  fetchingResetPassUrl: false,
  resetPassUrl: null,
  test: ' ',
  changePassword: null,
  changingPassword: false,
  changedPasswordMessage: null,
  changePasswordSuccess: false,
  moduleList: null,
  accountSettingsLoading: false,
  isErrorAccountSettings: false,

  userESignatureURL: null,

  generateLoginOtp: null,
  generateLoginOtpLoading: false,
  generateLoginOtpIsError: false,

  generateForgotOtp: null,
  generateForgotOtpLoading: false,
  generateForgotOtpIsError: false,

  changePasswordDetails: null,
  changePasswordDetailsLoading: false,
  changePasswordDetailsIsError: false,

  forgotMessageCount: 0,

  mqOpts: null,
  decodeValue: null,
  isError: false,

  descVisible: true
};

export default function authReducer(state = initState, action) {
  switch (action.type) {
    case actions.LOGIN_SUCCESS:
      const moduleData = generateSubmodules(action.modules);

      return {
        ...state,
        identity: JSON.parse(action.identity),
        idToken: action.token,
        topic: action.topic,
        moduleList: moduleData ? moduleData.defaultModule : [],
        modules: JSON.parse(action.modules),
        roles: JSON.parse(action.roles),
        customModules: moduleData ? moduleData.finalModule : [],
        errorMessage: null,
        env: action.env,
        mqOpts: action.mqOpts
      };
    case actions.SET_HELLO:
      return {
        ...state,
        test: action.label
      };
    case actions.LOGIN_ERROR:
      return {
        ...state,
        kickedOut: false,
        errorMessage: action.error,
        loginMessageCount: (state.loginMessageCount || 0) + 1
      };
    case actions.CLEAR_ERROR:
      return {
        ...state,
        errorMessage: null,
        loginMessageCount: state.loginMessageCount || 0
      };
    case actions.SET_LOADING:
      return {
        ...state,
        isLoading: action.loading
      };
    case actions.SIGNUP:
      return {
        ...state,
        isLoading: action.loading
      };
    case actions.SIGNUP_ERROR:
      return {
        ...state
      };
    case actions.FORGOT_ERROR:
      return {
        ...state,
        forgotMessage: action.error,
        forgotMessageCount: (state.forgotMessageCount || 0) + 1,
        isGeneratingForgotOtp: false
      };
    case actions.FORGOT_CLEAR:
      return {
        ...state,
        forgotMessage: null,
        forgotMessageCount: state.forgotMessageCount || 0
      };

    case actions.FORGOT_DESC_HIDE:
      return {
        ...state,
        descVisible: false
      };

    case actions.FORGOT_DESC_SHOW:
      return {
        ...state,
        descVisible: true
      };

    case actions.SUBMODULES:
      const mods3 = action.payload.filter(el => {
        const submods = el.submodules.filter(elB => {
          return state.disabledSubmodules.indexOf(elB.alias) < 0;
        });
        el.submodules = submods;
        return state.disabledModules.indexOf(el.alias) < 0;
      });
      return {
        ...state,
        modules: mods3
      };
    case actions.FORGOT_PASSWORD:
      return {
        ...state,
        email: action.email
      };
    case actions.FORGOT_PASSWORD_DONE:
      return {
        ...state,
        resetSuccess: action.success,
        forgotMessage: null
      };

    case actions.DECODE_VALUE_FAILED:
      return {
        ...state,
        error: action.error,
        decodeValue: null,
        isError: true
      };
    case actions.DECODE_VALUE_SUCCESS:
      return {
        ...state,
        error: null,
        decodeValue: action.result,
        isError: false
      };

    case actions.RESET_FORGOT_PASSWORD:
      return {
        ...state,
        resetSuccess: false,
        forgotMessage: null
      };

    case actions.RESET_SECOND_TIMER:
      return {
        ...state,
        secondTimer: action.secondTimer
      };
    case actions.KICKED_OUT:
      return {
        ...state,
        kickedOut: true
      };
    case actions.KICKED_OUT_CLEAR:
      return {
        ...state,
        kickedOut: false
      };
    case actions.LOGIN_VALIDATOR:
      return {
        ...state,
        mqttToken: action.token
      };
    case actions.FORBIDDEN_REQUEST:
      return {
        ...state,
        forbiddenRequest: true
      };
    case actions.LOGOUT:
      return {
        ...initState,
        mqOpts: null,
        kickedOut: state.kickedOut,
        errorMessage: state.errorMessage
      };
    case actions.FETCHING_RESET_PASSWORD_URL:
      return {
        ...state,
        fetchingResetPassUrl: true
      };
    case actions.FETCHED_RESET_PASSWORD_URL:
      return {
        ...state,
        fetchingResetPassUrl: false,
        resetPassUrl: action.resetPassUrl
      };
    case actions.CHANGING_PASSWORD:
      return {
        ...state,
        changingPassword: true
      };
    case actions.CHANGED_PASSWORD:
      return {
        ...state,
        changingPassword: false,
        changePasswordSuccess: true,
        changedPasswordMessage: null
      };
    case actions.CHANGED_PASSWORD_FAILED:
      return {
        ...state,
        changingPassword: false,
        changedPasswordMessage: action.payload
      };
    case actions.RESET_CHANGE_PASSWORD:
      return {
        ...state,
        changingPassword: false,
        changePasswordSuccess: false,
        changedPasswordMessage: null
      };

    case actions.UPDATING_USER_NOTIFICATION:
      return {
        ...state,
        isErrorAccountSettings: false,
        accountSettingsLoading: true
      };

    case actions.UPDATE_USER_NOTIFICATION_SUCCESS:
      return {
        ...state,
        accountSettingsLoading: action.loading,
        errorMessage: action.message,
        isErrorAccountSettings: false,
        identity: action.payload
      };

    case actions.UPDATE_USER_NOTIFICATION_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        accountSettingsLoading: action.loading,
        isErrorAccountSettings: true
      };

    case actions.UPDATING_USER_E_SIGNATURE:
      return {
        ...state,
        isErrorAccountSettings: false,
        accountSettingsLoading: true
      };

    case actions.UPDATE_USER_E_SIGNATURE_SUCCESS:
      return {
        ...state,
        accountSettingsLoading: action.loading,
        errorMessage: action.message,
        isErrorAccountSettings: false,
        identity: action.payload
      };

    case actions.UPDATE_USER_E_SIGNATURE_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        accountSettingsLoading: action.loading,
        isErrorAccountSettings: true
      };

    case actions.DELETE_USER_E_SIGNATURE_LOADING:
      return {
        ...state,
        isErrorAccountSettings: false,
        accountSettingsLoading: true
      };

    case actions.DELETE_USER_E_SIGNATURE_SUCCESS:
      return {
        ...state,
        accountSettingsLoading: action.loading,
        errorMessage: action.message,
        isErrorAccountSettings: false,
        identity: action.payload
      };

    case actions.DELETE_USER_E_SIGNATURE_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        accountSettingsLoading: action.loading,
        isErrorAccountSettings: true
      };

    case actions.FETCH_USER_E_SIGNATURE_URL:
      return {
        ...state,
        accountSettingsLoading: true,
        userESignatureURL: null
      };

    case actions.FETCH_USER_E_SIGNATURE_URL_SUCCESS:
      return {
        ...state,
        accountSettingsLoading: false,
        isErrorAccountSettings: false,
        userESignatureURL: action.result
      };

    case actions.FETCH_USER_E_SIGNATURE_URL_FAILED:
      return {
        ...state,
        accountSettingsLoading: false,
        isErrorAccountSettings: true
      };
    case actions.RESET_UPDATE_USER_NOTIFICATION:
      return {
        ...state,
        accountSettingsLoading: false,
        isErrorAccountSettings: false,
        errorMessage: null
      };
    case actions.UPDATE_ACTIVE_ROLE_MODULES:
      const updatedModule = generateSubmodules(JSON.stringify(action.payload));
      localStorage.setItem('customModules', JSON.stringify(updatedModule.finalModule));
      localStorage.setItem('modules', JSON.stringify(action.payload));
      return {
        ...state,
        modules: action.payload,
        customModules: updatedModule.finalModule
      };
    case actions.GENERATING_LOGIN_OTP:
      return {
        ...state,
        generateLoginOtp: null,
        generateLoginOtpLoading: true
      };
    case actions.GENERATE_LOGIN_OTP_SUCCESS:
      return {
        ...state,
        generateLoginOtp: action.result,
        generateLoginOtpLoading: false,
        generateLoginOtpIsError: false
      };
    case actions.GENERATE_LOGIN_OTP_FAILED:
      return {
        ...state,
        generateLoginOtp: null,
        generateLoginOtpLoading: false,
        generateLoginOtpIsError: true
      };
    case actions.RESET_GENERATE_LOGIN_OTP:
      return {
        ...state,
        generateLoginOtp: null,
        generateLoginOtpLoading: false,
        generateLoginOtpIsError: false
      };
    case actions.UPDATE_IDENTITY:
      return {
        ...state,
        identity: action.payload
      };
    case actions.UPDATING_OTP_SENDING:
      return {
        ...state,
        isErrorAccountSettings: false,
        accountSettingsLoading: true
      };

    case actions.UPDATE_OTP_SENDING_SUCCESS:
      return {
        ...state,
        accountSettingsLoading: action.loading,
        errorMessage: action.message,
        isErrorAccountSettings: false,
        identity: action.payload
      };

    case actions.UPDATE_OTP_SENDING_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        accountSettingsLoading: action.loading,
        isErrorAccountSettings: true
      };

    case actions.GENERATING_FORGOT_OTP:
      return {
        ...state,
        generateForgotOtp: null,
        generateForgotOtpLoading: true
      };
    case actions.GENERATE_FORGOT_OTP_SUCCESS:
      return {
        ...state,
        generateForgotOtp: action.result,
        generateForgotOtpLoading: false,
        error: null
      };
    case actions.GENERATE_FORGOT_OTP_FAILED:
      return {
        ...state,
        generateForgotOtp: null,
        generateForgotOtpLoading: false,
        generateForgotOtpIsError: true
      };
    case actions.RESET_GENERATE_FORGOT_OTP:
      return {
        ...state,
        generateForgotOtp: null,
        generateForgotOtpLoading: false,
        generateForgotOtpIsError: false
      };

    case actions.FETCHING_CHANGE_PASSWORD_DETAILS:
      return {
        ...state,
        changePasswordDetails: null,
        isLoading: action.loading,
        changePasswordDetailsLoading: action.loading
      };

    case actions.FETCH_CHANGE_PASSWORD_DETAILS_SUCCESS:
      return {
        ...state,
        changePasswordDetailsLoading: action.loading,
        isLoading: action.loading,
        changePasswordDetails: action.result,
        isError: false
      };

    case actions.FETCH_CHANGE_PASSWORD_DETAILS_FAILED:
      return {
        ...state,
        changePasswordDetailsLoading: action.loading,
        isLoading: action.loading,
        changePasswordDetails: action.result,
        isError: true,
        errorMessage: action.message
      };

    case actions.SUBMITTING_CHANGE_PASSWORD_DATA:
      return {
        ...state,
        changePasswordDetailsLoading: true,
        isLoading: true
      };

    case actions.SUBMIT_CHANGE_PASSWORD_DATA_SUCCESS:
      return {
        ...state,
        changePasswordDetailsLoading: action.loading,
        isLoading: action.loading,
        isError: false,
        errorMessage: action.message
      };

    case actions.SUBMIT_CHANGE_PASSWORD_DATA_FAILED:
      return {
        ...state,
        changePasswordDetailsLoading: action.loading,
        isLoading: action.loading,
        isError: true,
        errorMessage: action.message
      };

    default:
      return state;
  }
}

const generateSubmodules = modules => {
  try {
    let moduleData = JSON.parse(modules);
    let defaultModuleData = [];
    let finalModuleData = [];
    if (moduleData && moduleData.length > 0) {
      moduleData.forEach(module => {
        let currentModuleObj = {
          id: module.id,
          name: module.name,
          code: module.code,
          status: module.status
        };
        let pageArr = [];
        module.pages.forEach(page => {
          let currentPageObj = {
            id: page.id,
            name: page.name,
            code: page.code,
            status: page.status,
            privilege: { read: false, create: false, edit: false, delete: false }
          };
          let pageActionArr = [];
          page.page_action.forEach(action => {
            let currentPageActionObj = {
              id: action.id,
              name: action.name,
              code: action.code,
              is_active: false,
              description: action.description
            };
            pageActionArr.push(currentPageActionObj);
          });
          currentPageObj.page_action = pageActionArr;
          pageArr.push(currentPageObj);
        });
        currentModuleObj.pages = pageArr;
        defaultModuleData.push(currentModuleObj);
      });

      moduleData.forEach(module => {
        let currentModuleObj = {
          id: module.id,
          name: module.name,
          code: module.code,
          status: module.status
        };
        let pageArr = [];
        module.pages.forEach(page => {
          let currentPageObj = {
            id: page.id,
            name: page.name,
            code: page.code,
            status: page.status,
            privilege: page.privilege
          };
          let pageActionArr = [];
          let overAllActionStatus = page.page_action.every(
            pageAction => pageAction.is_active === false
          );
          if (!overAllActionStatus) {
            page.page_action.forEach(action => {
              let currentPageActionObj = {
                id: action.id,
                name: action.name,
                code: action.code,
                is_active: action.is_active,
                description: action.description
              };
              pageActionArr.push(currentPageActionObj);
            });
            currentPageObj.page_action = pageActionArr;
            pageArr.push(currentPageObj);
          }
        });
        if (pageArr.length > 0) {
          currentModuleObj.pages = pageArr;
          finalModuleData.push(currentModuleObj);
        }
      });
    }
    return {
      defaultModule: defaultModuleData,
      finalModule: finalModuleData
    };
  } catch (e) {
    return {};
  }
};
